import { API_URL, Blog_API_TOKEN, ENV, SOURCE_URL } from '../../config';

export const fetchBlog = async (lang: string) => {
  try {
    let langpart = '';
    if (lang.indexOf('zh') > -1) {
      langpart = "&locale=zh-Hant-HK&fallbackLocale=false";
    }
    let url = `${API_URL}/blog?populate=*&pagination[limit]=-1${langpart}`;
    let url2 = `${API_URL}/articles?populate=*&pagination[limit]=-1${langpart}`;
    let url3 = `${API_URL}/blog?populate=SEO.MetaImage&pagination[limit]=-1${langpart}`;
    if (ENV === 'preproduction') {
      url += url.indexOf('?') > -1 ? '&publicationState=preview' : '?publicationState=preview';
      url2 += url2.indexOf('?') > -1 ? '&publicationState=preview' : '?publicationState=preview';
      url3 += url3.indexOf('?') > -1 ? '&publicationState=preview' : '?publicationState=preview';
    }
    console.log('Fetching URLs:', url, url2, url3);

    const [response, response2, response3] = await Promise.all([
      fetch(url, { headers: { Authorization: `Bearer ${Blog_API_TOKEN}` } }),
      fetch(url2, { headers: { Authorization: `Bearer ${Blog_API_TOKEN}` } }),
      fetch(url3, { headers: { Authorization: `Bearer ${Blog_API_TOKEN}` } })
    ]);
    if (!response.ok || !response2.ok || !response3.ok) {
      console.error(`Error fetching Blog or Articles: ${response.statusText}`);
      return null;
    }

    const [responseData, articlesData, imageResponse] = await Promise.all([response.json(), response2.json(), response3.json()]);
    if(responseData?.data?.attributes?.SEO)
    responseData.data.attributes.SEO.MetaImage = SOURCE_URL + imageResponse.data.attributes.SEO.MetaImage?.data?.attributes?.url || null;
    console.log('Blog API Response:', responseData);
    console.log('Articles API Response:', articlesData);

    const articlesMap = new Map(articlesData.data.map((article: any) => [article.id, article]));

    const mapArticles = (articles: any) => articles.data.map((article: any) => articlesMap.get(article.id));

    const blogArticles = mapArticles(articlesData).sort((a: any, b: any) => new Date(b.attributes.updatedAt).getTime() - new Date(a.attributes.updatedAt).getTime());
    const hotArticles = mapArticles(responseData.data.attributes.HotArticles);
    const bannerArticles = mapArticles(responseData.data.attributes.BannerArticles);
    const categoryHotPickArticles = blogArticles.filter((article: any) => article.attributes?.Categories?.Categories?.includes("熱門文章_Hot Topics"));

    const combinedResponse = {
      ...responseData,
      data: {
        ...responseData.data,
        attributes: {
          ...responseData.data.attributes,
          Articles: blogArticles,
          HotArticles: hotArticles,
          BannerArticles: bannerArticles,
          CategoryHotPickArticles: categoryHotPickArticles
        },
      },
    };

    console.log('Blog Combined Response:', combinedResponse);
    return combinedResponse;

  } catch (error) {
    console.error('Error fetching Blog.', error);
    return null;
  }
};